import { Dispatch } from "redux";
import { Store } from "src/store";
import {
    deleteTradeInFailure,
    deleteTradeInRequest,
    deleteTradeInSuccess,
    patchTradeInFailure,
    patchTradeInRequest,
    patchTradeInSuccess,
} from "src/store/actions/tradeIn";
import { ActionType } from "src/store/dataService/actions/utils/actionCreator";
import { Yn } from "Types/TradeIn";
import { deleteTo, patchTo } from "./shared/osfetch";
import { findRoute } from "./util";

const patchTrade = async (next: Dispatch, action: ActionType<typeof patchTradeInRequest>) => {
    const response = await patchTo(
        `/deals/${action.payload.uuid}/tradein`,
        { ...action.payload.tradeIn, yn: Yn.Yes },
        next
    );
    if (response.ok) {
        const responseJSON = await response.json();

        next(patchTradeInSuccess(responseJSON));
    } else {
        next(patchTradeInFailure());
    }
};

export const removeTrade = async (next: Dispatch, action: ActionType<typeof deleteTradeInRequest>, store: Store) => {
    const response = await deleteTo(`/deals/${action.payload.uuid}/tradein`, {}, next, false);
    if (response.status === 200) {
        next(deleteTradeInSuccess());
    } else {
        next(deleteTradeInFailure());
    }
};

const routes = {
    [patchTradeInRequest.type]: patchTrade,
    [deleteTradeInRequest.type]: removeTrade,
};

export default (next: Dispatch, action: any, store?: Store) => findRoute(routes)(next, action, store);
